import {
  APPROVER_DATA,
  BULK_SUBMIT_WFH,
  EMPLOYEE_DATA,
  GET_DASHBOARD_DATA,
  GET_NOTIFICATION_MESSAGE,
  GET_USER_DETAILS,
  GET_USER_IMAGE,
  IS_VALID_APPROVER,
  IS_VALID_TOKEN,
  MEMBER_OR_LEADER_GRID,
  REQUEST_TYPE,
  SEASONS_STATUS_LIST,
  SESSION_EXPIRED,
  SET_ACTIVE_TAB,
  SET_PROGRESS_BAR,
  SET_SUPER_ADMIN_FLAG,
  USER_SEARCH_LIST,
} from "../constants/action-types";

let initialState = {
  employeeData: [],
  memberOrLeaderView: "",
  approverData: [],
  requestType: [],
  sessionExpired: false,
  getUserDetails: [],
  isValidApprover: [],
  isLoading: true,
  activeTab: [],
  isValidToken: false,
  submitWFH: [],
  userSearchList: [],
  superAdminView: false,
  userImage: null,
  notificationMessage: "",
  getDashboardData: [],
};

export const ptoReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPLOYEE_DATA:
      return {
        ...state,
        employeeData: action.payload,
      };

    case MEMBER_OR_LEADER_GRID:
      return {
        ...state,
        memberOrLeaderView: action.payload,
      };

    case APPROVER_DATA:
      return {
        ...state,
        approverData: action.payload,
      };

    case REQUEST_TYPE:
      return {
        ...state,
        requestType: action.payload,
      };

    case SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: action.payload,
      };

    case GET_USER_DETAILS:
      return {
        ...state,
        getUserDetails: action.payload,
      };

    case IS_VALID_APPROVER:
      return {
        ...state,
        isValidApprover: action.payload,
      };

    case SET_PROGRESS_BAR:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    case IS_VALID_TOKEN:
      return {
        ...state,
        isValidToken: action.payload,
      };

    case BULK_SUBMIT_WFH:
      return {
        ...state,
        submitWFH: action.payload,
      };

    case USER_SEARCH_LIST:
      return {
        ...state,
        userSearchList: action.payload,
      };

    case SEASONS_STATUS_LIST:
      return {
        ...state,
        seasonsStatusList: action.payload,
      };

    case SET_SUPER_ADMIN_FLAG:
      return {
        ...state,
        superAdminView: action.payload,
      };

    case GET_USER_IMAGE:
      return {
        ...state,
        userImage: action.payload,
      };

    case GET_NOTIFICATION_MESSAGE:
      return {
        ...state,
        notificationMessage: action.payload,
      };

    case GET_DASHBOARD_DATA:
      return {
        ...state,
        getDashboardData: action.payload,
      };

    default:
      return state;
  }
};
